
(function () {

    'use strict';
    angular.module('app')
        .service('exportAccountsService', ['$http', function ($http) {
            this.exportAccounts = function (startDate, endDate) {
                return $http.get('api/account/exportAccounts',
                    { params: { startDate: startDate, endDate: endDate } })
                    .then(function (response) {
                        return response.data;
                    },
                        function () {
                            throw ('Export Accounts Retrieval Failure');
                        });
            };
        }]
            );
})();